export default {
  selection: "系统语言选择",
  english: "English",
  simplified_chinese: "中文 （简体）",
  list: {
    en: "英文",
    zh: "中文（简体）",
    tw: "中文（繁体）",
    vi: "越南文",
    th: "泰文",
    id: "印度尼西亚文",
    malay: "马来文",
    jp: "日文",
    kr: "韩文",
    my: "缅甸",
    ar: "阿根廷",
    ru: "俄罗斯"
  }
};
